module.exports = __webpack_public_path__ + "static/img/iot4.fb97b35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/iot4.png
// module id = N02P
// module chunks = 0